import React from 'react';

import PolarAreaChart from '../../../components/charts/apex/polar-area/PolarArea';
import { SONAR_DATA_KEYS } from '../../../utils/chart';

function Presence({ domainEntries }) {
  return <PolarAreaChart data={domainEntries} dataKey={SONAR_DATA_KEYS.PRESENCE} />;
}

export default Presence;
